import { api } from './api';

export interface Cidade {
  nome: string;
  peso: 'alta' | 'media' | 'emergente' | string;
  fatores: string[];
  motivo: string;
}

export interface CidadesResponse {
  uf_nomes: Record<string, string>;
  estados: Record<string, Cidade[]>;
  resumo: Record<string, { nome: string; total: number; alta: number }>;
}

export interface EstadoConfig {
  ativo: boolean;
  cap_dia: number;
}

export interface EstadosConfigResponse {
  estados: Record<string, EstadoConfig>;
}

export interface DiaClima {
  data: string;
  tmax: number | null;
  tmin: number | null;
  sensacao_max: number | null;
  precip: number | null;
  prob_chuva: number | null;
  vento: number | null;
  rajada: number | null;
  uv: number | null;
  nascer: string | null;
  por: string | null;
  code: number | null;
  condicao: string;
}

export interface AgoraClima {
  temp: number | null;
  umidade: number | null;
  sensacao: number | null;
  vento: number | null;
  code: number | null;
  condicao: string;
}

export interface AlertaClima {
  ativo: boolean;
  tipo?: string | null;
  motivo?: string;
}

export interface EstadoClima {
  cidade: string;
  agora: AgoraClima;
  hoje: DiaClima;
  amanha: DiaClima;
  alerta: AlertaClima;
}

export interface ClimaInsight {
  chave: string;
  titulo: string;
  uf: string;
  cidade: string;
  valor: string;
  sugestao: string;
}

export interface ClimaResponse {
  estados: Record<string, EstadoClima>;
  config: { anomaly_sigma: number; precip_alerta_mm: number; vento_alerta_kmh: number; enabled: boolean };
  insights: ClimaInsight[];
}

export const geoApi = {
  getClima: (): Promise<ClimaResponse> => api.get<ClimaResponse>('/geo/clima'),
  getCidades: (): Promise<CidadesResponse> =>
    api.get<CidadesResponse>('/geo/cidades'),
  saveCidades: (estados: Record<string, Cidade[]>): Promise<{ estados: Record<string, Cidade[]> }> =>
    api.put('/geo/cidades', { estados }),
  getEstadosConfig: (): Promise<EstadosConfigResponse> =>
    api.get<EstadosConfigResponse>('/geo/estados-config'),
  saveEstadosConfig: (estados: Record<string, EstadoConfig>): Promise<EstadosConfigResponse> =>
    api.put<EstadosConfigResponse>('/geo/estados-config', { estados }),
};
